import type { User, UserRole } from '@/types';

const ROLE_ALIASES: Partial<Record<UserRole, UserRole>> = {
  manager: 'sales_manager',
  operator: 'production',
  viewer: 'executive',
  user: 'sales_manager',
  guest: 'sales_manager',
  partner_admin: 'partner',
  partner_user: 'partner',
  partner_accountant: 'partner',
};

export const normalizeUserRole = (role?: UserRole | null): UserRole | undefined => {
  if (!role) return undefined;
  return ROLE_ALIASES[role] || role;
};

const getPrimaryRole = (user?: User | null): UserRole | undefined =>
  normalizeUserRole(user?.roles?.[0] || user?.role);

export const isAdminUser = (user?: User | null): boolean => {
  if (!user) return false;
  return user.role === 'admin' || Boolean(user.roles?.includes('admin'));
};

// FLOW[46561]: супервайзер CRM — видит ВСЮ базу лидов/клиентов и переназначает
// владельцев (зеркало CRM_SUPERVISOR_ROLES в client-service/app/auth.py).
// Сравниваем СЫРЫЕ роли без алиасов normalizeUserRole: бэкенд проверяет роль
// из JWT как есть, и фронт не должен показывать супервайзерский UI там,
// где бэкенд ответит 403 (например, viewer → executive-алиас).
const CRM_SUPERVISOR_ROLES = new Set(['admin', 'executive', 'sales_head']);

export const isCrmSupervisor = (user?: User | null): boolean => {
  if (!user) return false;
  if ((user as { is_superuser?: boolean }).is_superuser) return true;
  const roles = [user.role, ...(user.roles || [])];
  return roles.some(
    (role) => Boolean(role) && CRM_SUPERVISOR_ROLES.has(String(role).toLowerCase())
  );
};

export const getEffectiveRole = (
  user?: User | null,
  viewRole?: UserRole | null
): UserRole | undefined => {
  const primary = getPrimaryRole(user);
  if (!primary) return undefined;
  if (!viewRole) return primary;
  return isAdminUser(user) ? viewRole : primary;
};

export const getEffectiveRoles = (
  user?: User | null,
  viewRole?: UserRole | null
): UserRole[] => {
  const effective = getEffectiveRole(user, viewRole);
  return effective ? [effective] : [];
};
